import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PartnersIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "17",
        height: "18",
        viewBox: "0 0 17 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_528_1019)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.96875 16.4375C5.9962 16.4375 4.10444 15.6539 2.70964 14.2591C1.31484 12.8643 0.53125 10.9726 0.53125 9C0.53125 7.02745 1.31484 5.13569 2.70964 3.74089C4.10444 2.34609 5.9962 1.5625 7.96875 1.5625",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.96875 1.5625C7.96875 1.5625 4.25 3.6875 4.25 9C4.25 14.3125 7.96875 16.4375 7.96875 16.4375",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.96894 5.8125H1.24756",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.96894 12.1875H1.24756",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.1562 3.6875C11.1562 4.25109 11.3802 4.79159 11.7787 5.1901C12.1772 5.58862 12.7177 5.8125 13.2812 5.8125C13.8448 5.8125 14.3853 5.58862 14.7838 5.1901C15.1823 4.79159 15.4062 4.25109 15.4062 3.6875C15.4062 3.12391 15.1823 2.58341 14.7838 2.1849C14.3853 1.78638 13.8448 1.5625 13.2812 1.5625C12.7177 1.5625 12.1772 1.78638 11.7787 2.1849C11.3802 2.58341 11.1562 3.12391 11.1562 3.6875Z",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M15.13 7.47437L13.2812 10.0626L11.4325 7.47437C11.019 7.76775 10.6818 8.1557 10.449 8.60599C10.2161 9.05621 10.0942 9.55565 10.0938 10.0626V12.1876C10.0938 12.4694 10.2057 12.7397 10.4049 12.9389C10.6042 13.1382 10.8745 13.2501 11.1562 13.2501H11.6875V15.3751C11.6875 15.6569 11.7994 15.9272 11.9987 16.1264C12.1979 16.3257 12.4682 16.4376 12.75 16.4376H13.8125C14.0943 16.4376 14.3646 16.3257 14.5638 16.1264C14.7631 15.9272 14.875 15.6569 14.875 15.3751V13.2501H15.4062C15.688 13.2501 15.9583 13.1382 16.1576 12.9389C16.3568 12.7397 16.4687 12.4694 16.4687 12.1876V10.0626C16.4683 9.55565 16.3464 9.05621 16.1135 8.60599C15.8807 8.1557 15.5435 7.76775 15.13 7.47437Z",
                        stroke: "#6161FF",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_528_1019",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "17",
                        height: "17",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
